import axios from "axios";

const token = sessionStorage.getItem("user");

const axiosConfig = axios.create({
  baseURL: "https://api.meetmontenegro.me",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});

axiosConfig.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("user");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosConfig;
